// [리메이크] 선택 모달 — 재제작 / 수리 / 취소 (2026-09-04 대표 승인)
// 경고 기준(2026-09-29 무접촉 공정 흐름): 수동 도착 기록 없음 && 자동 완료(auto_due) 아님 && 도착 예정일 미경과 → '아직 도착 예정일 전' 안내.
// 고른 값은 remakeKind로 돌려준다.
import React from 'react';
import { REMAKE_KINDS } from '../../utils/remakeKind';

// 도착 예정일(납기) 경과 여부 — dueDate(Timestamp/Date) 또는 구건 문자열 deliveryDate. 날짜를 못 읽으면 '경과'로 본다(경고를 지어내지 않음).
const dueElapsed = (o) => {
    const raw = o?.dueDate || o?.deliveryDate;
    if (!raw) return true;
    const d = raw?.toDate ? raw.toDate() : new Date(raw);
    if (isNaN(d)) return true;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const due = new Date(d); due.setHours(0, 0, 0, 0);
    return due.getTime() < today.getTime();
};

export default function RemakeKindModal({ order, onPick, onClose }) {
    if (!order) return null;
    const name = order.patientName || '이 환자';
    const warn = !order.receivedAt && order.stageSource !== 'auto_due' && !dueElapsed(order);
    return (
        <div onClick={onClose} style={M.backdrop}>
            <div onClick={(e) => e.stopPropagation()} style={M.box} role="dialog" aria-modal="true">
                <div style={M.title}>{name + '의 지난 의뢰서로 새 의뢰서를 만듭니다'}</div>
                {warn ? (
                    <div style={M.warn}>
                        {'아직 도착 예정일 전인 건입니다.\n제작 중인 기공물이 있을 수 있고, 그대로 보내면 같은 의뢰가 두 건이 됩니다.'}
                    </div>
                ) : (
                    <div style={M.sub}>{'환자·기공소·치식·재료·쉐이드가 채워진 채로 열립니다. 어떤 의뢰인지 골라 주세요.'}</div>
                )}
                <div style={M.row}>
                    {REMAKE_KINDS.map(k => (
                        <button key={k.key} type="button" onClick={() => onPick(k.key)}
                            style={{ ...M.pick, ...(k.key === 'repair' ? M.pickRepair : M.pickRemake) }}>
                            <div style={{ fontSize: 15, fontWeight: 800 }}>{k.label}</div>
                            <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.85, marginTop: 3 }}>{k.desc}</div>
                        </button>
                    ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
                    <button type="button" onClick={onClose} style={M.cancel}>{'취소'}</button>
                </div>
            </div>
        </div>
    );
}

const M = {
    backdrop: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
    box: { width: '100%', maxWidth: 440, background: '#fff', borderRadius: 14, padding: '20px 20px 16px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)', fontFamily: 'inherit' },
    title: { fontSize: 16, fontWeight: 800, color: '#0f172a', marginBottom: 8, lineHeight: 1.4 },
    sub: { fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 14 },
    warn: { fontSize: 13, color: '#991b1b', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '9px 11px', lineHeight: 1.6, whiteSpace: 'pre-line', marginBottom: 14 },
    row: { display: 'flex', gap: 10 },
    pick: { flex: 1, padding: '12px 10px', borderRadius: 10, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit' },
    pickRemake: { border: '2px solid #fecaca', background: '#fef2f2', color: '#991b1b' },
    pickRepair: { border: '2px solid #a5f3fc', background: '#ecfeff', color: '#155e75' },
    cancel: { padding: '7px 14px', borderRadius: 8, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
};
